import { DESCENDING } from 'constants/sortDirections';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { Segment } from '../components/Audience/types';

type TabSpecificFiltersContextState = {
  campaignsSortedBy: string;
  setCampaignsSortedBy: (campaignsSortedBy: string) => void;
  campaignsSortDirection: string;
  setCampaignsSortDirection: (campaignsSortDirection: string) => void;
  audienceSortedBy: string;
  setAudienceSortedBy: (audienceSortedBy: string) => void;
  audienceSortDirection: string;
  setAudienceSortDirection: (audienceSortDirection: string) => void;
  selectedSegment: Segment;
  setSelectedSegment: (segment: Segment) => void;
  region: string[];
  setRegion: (region: string[]) => void;
  snippetsSortedBy: string;
  setSnippetsSortedBy: (audienceSortedBy: string) => void;
  snippetsSortDirection: SORT_DIRECTIONS;
  setSnippetsSortDirection: (audienceSortDirection: SORT_DIRECTIONS) => void;
};

export const defaultTabSpecificFiltersState = {
  campaignsSortedBy: 'id',
  setCampaignsSortedBy: noop,
  campaignsSortDirection: DESCENDING,
  setCampaignsSortDirection: noop,
  audienceSortedBy: 'Segment',
  setAudienceSortedBy: noop,
  audienceSortDirection: DESCENDING,
  setAudienceSortDirection: noop,
  selectedSegment: {},
  setSelectedSegment: noop,
  region: ['021'],
  setRegion: noop,
  snippetsSortedBy: 'TotalSent',
  setSnippetsSortedBy: noop,
  snippetsSortDirection: SORT_DIRECTIONS.DESCENDING,
  setSnippetsSortDirection: noop,
};

export const TabSpecificFiltersContext = createContext<TabSpecificFiltersContextState>(
  defaultTabSpecificFiltersState,
);

export const useTabSpecificFiltersContext = () => useContext(TabSpecificFiltersContext);
